module.exports = __webpack_public_path__ + "static/pt-8ce156e00aa8ae4407eb5c1efae8f5fd.svg";